import { useState } from "react";
import {
  Input,
  Select,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  HStack,
  useDisclosure,
  useToast,
  Box,
  FormLabel,
  Flex,
} from "@chakra-ui/react";
import { addNewTax } from "../../../actions/management.action";
import LabelInput from "../../../components/Input";

const AddTax = ({ reload }) => {
  const toast = useToast();
  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  const [formData, setFormData] = useState({
    state: "",
    tollTax: "",
    stateTax: "",
  });
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addNewTax(formData)
      .then(() => {
        toast({
          title: "Success",
          description: "New tax added",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        reload();
      })
      .catch((err) => {
        console.log(err);
        toast({
          title: "Error",
          description: err?.message || "Something went wrong",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
    onClose();
  };

  return (
    <>
      <HStack>
        <Button
          onClick={onOpen}
          colorScheme="blue"
          borderRadius={5}
          size={"md"}
          px={10}
          fontWeight={0}
        >
          + Add Tax
        </Button>
      </HStack>

      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent borderRadius={"lg"} boxShadow="lg" margin={2}>
            <AlertDialogHeader fontSize="lg" mb={1} color={"#1A202C"}>
              Add Tax Details
            </AlertDialogHeader>

            <AlertDialogBody>
              <form onSubmit={handleSubmit}>
                {/* <Select
                  name="state"
                  placeholder="Select State"
                  value={formData.state}
                  onChange={handleChange}
                  mb={4}
                >
                  {states.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </Select> */}
                <Flex flexDirection={"column"} gap={4}>
                <Box>
                  <FormLabel fontSize="md" htmlFor="state">Select State</FormLabel>
                  <Select
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    placeholder="Select Your State"
                    _placeholder={{ fontSize: "sm", fontcolor: "grey.300" }}
                    variant={"filled"}
                    borderRadius={"lg"}
                    _focus={{
                      borderColor: "blue.500",
                      boxShadow: "0 0 0 1px blue.500",
                    }}
                    h={"56px"}
                  >
                    {states.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </Select>
                </Box>
                <LabelInput
                  name="tollTax"
                  placeholder="Toll Tax"
                  label="Toll Tax"
                  value={formData.tollTax}
                  onChange={handleChange}
                  mb={4}
                />
                <LabelInput
                  name="stateTax"
                  placeholder="State Tax"
                  label="State Tax"
                  value={formData.stateTax}
                  onChange={handleChange}
                  mb={4}
                />
                </Flex>
              </form>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                onClick={onClose}
                variant="outline"
                mr={3}
                  borderColor="#396AFF"
                  borderWidth={2}
                  color="#396AFF"
                  size={"sm"}
                  bg="white"
                  _hover={{
                    border: "none",
                    bg: "grey",
                    color: "black"
                  }}
                  borderRadius={5}
                  px={6}
                  fontWeight={600}
                  py={5}  
              >
                Cancel
              </Button>
              <Button
                type="submit"
                colorScheme="blue"
                onClick={handleSubmit}
                 borderColor="#396AFF"
                borderWidth={2} size={"sm"} borderRadius={5}
                px={12}
                fontWeight={600}
                w={"20%"}
                py={5}
              >
                Submit
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default AddTax;
